import TriggerActions from '../actions/TriggerCRUDActions';
import Actions from '../actions/actions';
import {
  setBusy,
  setUnBusy,
  update,
  deleteLocalFirst,
  addEntity,
} from './common/commonReducers';
import { TriggerState } from '../interfaces/trigger';
import TriggerModel from '../model/TriggerModel';
import { Pagination } from '../store-interfaces';

const initialState: TriggerState = {
  busy: false,
  entities: [],
};

const showBoosted = (trigger: TriggerModel) => {
  const phrases =
    trigger?.phrases?.map(item => ({
      ...item,
      phrase: item.boosted ? `+ ${item.phrase}` : item.phrase,
    })) || [];

  return {
    ...trigger,
    phrases,
  };
};

const retrievedAll = (
  state: TriggerState,
  action: { triggers: TriggerModel[]; pagination?: Pagination },
) => {
  const { triggers, pagination } = action;

  const entities = triggers.map((item: TriggerModel) => showBoosted(item));

  return {
    ...state,
    busy: false,
    entities,
    pagination,
  };
};

export default function trigger(state = initialState, action) {
  switch (action.type) {
    case TriggerActions.busyAction:
      return setBusy(state);
    case TriggerActions.retrievedAction:
      return addEntity(state, action);
    case TriggerActions.retrievedAllAction:
      return retrievedAll(state, action);
    case TriggerActions.updateAction: {
      const entity = showBoosted(action.entity);
      const updatedAction = { ...action, entity };
      return update(state, updatedAction);
    }
    case TriggerActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case TriggerActions.unsetTriggersAction:
      return initialState;
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
